// src/components/customer/blog/BlogSidebar.jsx
import React from "react";
import { Form, Badge, Button } from "react-bootstrap";
import { FiFacebook, FiTwitter, FiLinkedin, FiMail } from "react-icons/fi";
import BlogCard from "../../../components/customer/blogsinglecard/BlogSingleCard";
import "../../../assets/css/customer/components/BlogSidebar.css";

const BlogSidebar = ({
  relatedBlogs = [],
  popularBlogs = [],
  keywords = "",
}) => {
  return (
    <div className="blog-sidebar">
      {/* Search Widget */}
      {/* <div className="sidebar-widget">
        <Form.Control
          type="text"
          placeholder="SEARCH"
          className="sidebar-search-input"
        />
      </div> */}

      {/* Related Posts */}
      {relatedBlogs.length > 0 && (
        <div className="sidebar-widget">
          <h4 className="sidebar-widget-title">RELATED POSTS</h4>
          <div className="sidebar-posts-list">
            {relatedBlogs.map((blog) => (
              <BlogCard key={blog.id} blog={blog} variant="sidebar" />
            ))}
          </div>
        </div>
      )}

      {/* Popular Posts */}
      {/* {popularBlogs.length > 0 && (
        <div className="sidebar-widget">
          <h4 className="sidebar-widget-title">POPULAR POSTS</h4>
          <div className="sidebar-posts-list">
            {popularBlogs.map(blog => (
              <BlogCard key={blog.id} blog={blog} variant="sidebar" />
            ))}
          </div>
        </div>
      )} */}

      {/* Tags */}
      <div className="sidebar-widget">
        <h4 className="sidebar-widget-title">TAGS</h4>
        <div className="sidebar-tags-list">
          {(Array.isArray(keywords) ? keywords : (keywords?.split(", ") ?? []))
            .filter(Boolean)
            .map((tag, idx) => (
              <Badge key={idx} bg="light" text="dark" className="sidebar-tag">
                {tag}
              </Badge>
            ))}
        </div>
      </div>

      {/* Follow Us */}
      {/* <div className="sidebar-widget">
        <h4 className="sidebar-widget-title">FOLLOW US</h4>
        <div className="sidebar-social-icons">
          <Button variant="outline-secondary" className="sidebar-social-btn">
            <FiFacebook size={18} />
          </Button>
          <Button variant="outline-secondary" className="sidebar-social-btn">
            <FiTwitter size={18} />
          </Button>
          <Button variant="outline-secondary" className="sidebar-social-btn">
            <FiLinkedin size={18} />
          </Button>
          <Button variant="outline-secondary" className="sidebar-social-btn">
            <FiMail size={18} />
          </Button>
        </div>
      </div> */}
    </div>
  );
};

export default BlogSidebar;
